import React, { useEffect, useState } from 'react'
import Sidebar from '../components/Sidebar'
import Slider from "react-slick";
import DashboardSlider from '../components/DashboardSlider';
import GameCard from '../components/GameCard';
import Skeleton1 from '../components/Skeleton1';
import Skeleton2 from '../components/Skeleton2';
import { Outlet } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import LogoutButton from '../components/LogoutButton';
import { useIsMobile } from '../helpers/IsMobile'
import { CircleX } from 'lucide-react';

import GTranslateDropdown from '../components/GTranslateDropdown';

export default function Home() {
    const isMobile = useIsMobile();
    const navigate = useNavigate();

    const [data, setData] = useState([])
    const [loading, setloading] = useState(false)
    const [clearbutton, setClearButton] = useState(false)

    const [recentlyAdded, setRecentlyAdded] = useState([]);
    const [popularGames, setPopularGames] = useState([]);
    const [bestGames, setBestGames] = useState([]);
    const [randomGames, setRandomGames] = useState([]);
    const [heroGame, setHeroGame] = useState(null); // this will be used in the hero section

    useEffect(() => {
        if (window.AOS) {
            window.AOS.init({ duration: 500 });
        }
    }, []);

    const handleGameSelect = (game) => {
        setRandomGames((prev) => {
            const filtered = prev.filter(g => g.ID !== game.ID);
            return [game, ...filtered];
        });
         window.scrollTo(0, 0);
    };


    useEffect(() => {

        setloading(true);

        const params = new URLSearchParams(window.location.search);
        const urlphone = params.get('Phonenumber');


        console.log(urlphone)
        const sessionData = sessionStorage.getItem("GPP_Games_Data");

        const processGames = (allGames) => {
            const recentlyAdded = [...allGames].sort((a, b) => b.ID - a.ID);
            const popularGames = [...allGames].sort((a, b) => parseInt(b.PlayCount) - parseInt(a.PlayCount));
            const bestGames = [...allGames].sort((a, b) => parseFloat(b.avrate) - parseFloat(a.avrate));

            const randomGames = [...allGames]
                .sort(() => 0.5 - Math.random()) // Shuffle
                .slice(0, 10); // Get 10 items

            setRecentlyAdded(recentlyAdded);
            setPopularGames(popularGames);
            setBestGames(bestGames);
            setRandomGames(randomGames);

        };


        if (!sessionData) {
            fetch(`https://apiv2.mobileartsme.com/gbox_getcontent_new`)
                .then(resp => resp.json())
                .then(data => {
                    const categories = data.Content[0].HTML5;
                    const allGames = categories.flatMap(category => category.Content);

                    sessionStorage.setItem('GPP_Games_Data', JSON.stringify(categories));
                    setData(categories);
                    processGames(allGames);
                    setloading(false);
                });
        } else {
            const storedData = JSON.parse(sessionData);
            const allGames = storedData.flatMap(category => category.Content);

            setData(storedData);
            processGames(allGames);

            setloading(false);
        }
    }, []);


    var settings_1 = {
        dots: false,
        arrows: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };



    var settings_2 = {
        dots: false,
        arrows: false,
        infinite: false,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 1,

        responsive: [
            {
                breakpoint: 1324,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 1224,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3.2,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2.5,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2.2,
                    slidesToScroll: 1
                }
            }
        ]

    };



    const [searchTerm, setSearchTerm] = useState('');
    const [searchResults, setSearchResults] = useState([]);

    const handleSearch = (e) => {
        setClearButton(true)
        const value = e.target.value;
        setSearchTerm(value);

        if (value.trim() === '') {
            setSearchResults([]);
            return;
        }

        const sessionData = sessionStorage.getItem("GPP_Games_Data");
        if (sessionData) {
            const storedData = JSON.parse(sessionData);
            const allGames = storedData.flatMap(category => category.Content);

            const filtered = allGames.filter(game =>
                game.Title.toLowerCase().includes(value.toLowerCase()) ||
                game.Description.toLowerCase().includes(value.toLowerCase())
            );

            setSearchResults(filtered);
        }
    };

    const selectSearchedGame = (game) => {
        setSearchResults([]);
        handleGameSelect(game)
       
    }

    const clearSearch = () => {
        setClearButton(false)
        setSearchResults([]);
        setSearchTerm('');
    }



    return (
        <div>
            <Sidebar />

            <div className='main-body' >

                <div className='mb-3'>

                    <div className='d-flex flex-row align-items-center justify-content-between mb-2' >
                        <h4 className='my-3' ><strong>Home</strong></h4>
                        <div className='d-flex flex-row align-items-center justify-content-center gap-2' >
                            <GTranslateDropdown />
                            {isMobile ? <LogoutButton /> : ""}
                        </div>


                    </div>

                    <div className="input-wrapper">
                        <input
                            type="text"
                            placeholder="Search games ..."
                            value={searchTerm}
                            onChange={handleSearch}

                        />
                        {clearbutton ? <button className='btn-clear' onClick={() => clearSearch()} ><CircleX /></button> : ''}
                    </div>

                    {searchResults.length > 0 && (
                        <div className="search-results">
                            {searchResults.map(game => (
                                <div
                                    key={game.ID}
                                    className="d-flex flex-row align-items-center justify-content-between  p-2 border-bottom"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => selectSearchedGame(game)}>

                                    <div className='d-flex flex-row algin-items-center' >
                                        <img
                                            src={game.Thumbnail_Large}
                                            alt={game.Title}
                                            style={{ width: '90px', height: '100%', objectFit: 'cover', borderRadius: '8px', marginRight: '12px' }}
                                        />
                                        <div>
                                            <strong>{game.Title}</strong>
                                            <p className="mb-0">{game.Description}</p>
                                        </div>
                                    </div>

                                    <button className='btn btn-primary' style={{ fontSize: '0.8rem', minWidth: '100px' }} >Play Now</button>

                                </div>
                            ))}
                        </div>
                    )}



                </div>


                {loading ? (
                    <Skeleton1 />

                ) : data.length > 0 && data[0]?.Content ? (
                    <Slider {...settings_1}>
                        {randomGames.map((game, index) => (
                            <div className="slick-slide-gap" key={index}>

                                <DashboardSlider key={index} game={game} />
                            </div>
                        ))}
                    </Slider>
                ) : (
                    <div>No games available</div>
                )}


                {loading ? (
                    <div>

                        <div className='my-5' >
                            <div className='skeleton-title' ></div>
                            <Skeleton2 />
                        </div>
                        <div className='my-5' >
                            <div className='skeleton-title' ></div>
                            <Skeleton2 />
                        </div>
                        <div className='my-5' >
                            <div className='skeleton-title' ></div>
                            <Skeleton2 />
                        </div>
                    </div>
                ) : (

                    <div>
                        <div className='my-5' >
                            <div className='mb-2 d-flex flex-row align-items-center justify-content-between' >
                                <h4>Recently Added</h4>
                                <p className='m-0' style={{ cursor: 'pointer' }}
                                    onClick={() =>
                                        navigate('/dashboard/single', {
                                            state: {
                                                category: {
                                                    Name: 'Recently Added',
                                                    Content: recentlyAdded
                                                }
                                            } // passing data via state
                                        })
                                    }
                                >View all</p>
                            </div>

                            <Slider {...settings_2}>
                                {recentlyAdded.map((game, index) => (
                                    <GameCard key={index} game={game} onInfoClick={handleGameSelect} />
                                ))}
                            </Slider>
                        </div>

                        <div className='my-5' >

                            <div className='mb-2 d-flex flex-row align-items-center justify-content-between' >
                                <h4>Popular Games</h4>
                                <p className='m-0' style={{ cursor: 'pointer' }}
                                    onClick={() =>
                                        navigate('/dashboard/single', {
                                            state: {
                                                category: {
                                                    Name: 'Popular Games',
                                                    Content: popularGames
                                                }
                                            } // passing data via state
                                        })
                                    }
                                >View all</p>
                            </div>

                            <Slider {...settings_2}>
                                {popularGames.map((game, index) => (
                                    <GameCard key={index} game={game} onInfoClick={handleGameSelect} />
                                ))}
                            </Slider>
                        </div>

                        <div className='my-5' >
                            <div className='mb-2 d-flex flex-row align-items-center justify-content-between' >
                                <h4>Best Games</h4>
                                <p className='m-0' style={{ cursor: 'pointer' }}
                                    onClick={() =>
                                        navigate('/dashboard/single', {
                                            state: {
                                                category: {
                                                    Name: 'Best Games',
                                                    Content: bestGames
                                                }
                                            } // passing data via state
                                        })
                                    }
                                >View all</p>
                            </div>

                            <Slider {...settings_2}>
                                {bestGames.map((game, index) => (
                                    <GameCard key={index} game={game} onInfoClick={handleGameSelect} />
                                ))}
                            </Slider>
                        </div>
                    </div>
                )}



            </div>
            <Outlet />
        </div>
    )
}
